import { NavigationSideItem } from '../types';

export const navigationSideMainConfig: NavigationSideItem[] = [
  {
    icon: 'pi pi-home',
    title: 'navigation.dashboard.label',
    id: 'dashboard',
    routerLink: '/panel/dashboard',
  },
  {
    icon: 'pi pi-server',
    title: 'navigation.environments.label',
    id: 'environments',
    routerLink: '/panel/environments',
  },
  {
    icon: 'pi pi-mobile',
    title: 'navigation.apps.label',
    id: 'apps',
    routerLink: '/panel/apps',
  },
  {
    icon: 'pi pi-sitemap',
    title: 'navigation.flows.label',
    id: 'flows',
    routerLink: '/panel/flows',
  },
  {
    icon: 'pi pi-desktop',
    title: 'navigation.desktopFlows.label',
    id: 'desktop-flows',
    routerLink: '/panel/desktop-flows',
  },
  {
    icon: 'pi pi-android',
    title: 'navigation.bots.label',
    id: 'bots',
    routerLink: '/panel/bots',
  },
  /*{
    icon: 'pi pi-pen-to-square',
    title: 'navigation.formGenerator.label',
    id: 'form-generator',
    routerLink: '/panel/form-generator',
  },*/
];

export const navigationSideMainAdminConfig: NavigationSideItem[] = [
  {
    icon: 'pi pi-trophy',
    title: 'navigation.compliance.label',
    id: 'compliance',
    routerLink: '/panel/compliance',
  },
  {
    icon: 'pi pi-users',
    title: 'navigation.tenantUsersMngt.label',
    id: 'usersmngt',
    routerLink: '/panel/tenant-admin/users',
  },
  {
    icon: 'pi pi-cog',
    title: 'navigation.tenantSettingsMngt.label',
    id: 'settingsmngt',
    routerLink: '/panel/tenant-admin/settings',
  },
  {
    icon: 'pi pi-history',
    title: 'navigation.tenantAuditLogsMngt.label',
    id: 'auditlogsmngt',
    routerLink: '/panel/tenant-admin/audit-logs',
  },
];

export const navigationSideMainPowerAdminConfig: NavigationSideItem[] = [
  {
    icon: 'pi pi-briefcase',
    title: 'navigation.powerAdminDbTenantMngt.label',
    id: 'dbtenantsmngt',
    routerLink: '/panel/power-admin/tenants',
  },
];

export const navigationSideExtraConfig: NavigationSideItem[] = [
  {
    icon: 'pi pi-sign-out',
    title: 'navigation.signOut.label',
    id: 'signOut',
  },
  /*{
    icon: 'pi pi-sun',
    title: 'navigation.darkMode.label',
    id: 'darkModeToggle',
    onlyIfDarkMode: true,
  },
  {
    icon: 'pi pi-moon',
    title: 'navigation.notDarkMode.label',
    id: 'darkModeToggle',
    onlyIfNotDarkMode: true,
  },*/
  {
    icon: 'pi pi-angle-double-right',
    title: 'navigation.expand.label',
    id: 'expand',
  },
];
